export const isProduction = import.meta.env.MODE === 'production';

export const keyMapMetadata: Record<string, string> = {
  category: 'Thư mục gốc',
  fileName: 'Tên tệp',
  fullPath: 'Đường dẫn đầy đủ',
  createAt: 'Ngày tạo',
  creator: 'Người tạo',
  creatorId: 'ID người tạo',
  DataSource: 'Nguồn dữ liệu',
  SuggestedAICategories: 'Danh mục AI gợi ý',
  KeywordAISuggestion: 'Từ khóa AI gợi ý',
  SummaryOfSuggestedAI: 'Tóm tắt AI gợi ý',
  AccessLevel: 'Cấp độ truy cập',
  path: 'Đường dẫn',
  summary: 'Trích yếu',
  effectiveDate: 'Ngày hiệu lực',
  expirationDate: 'Ngày hết hiệu lực',
  issueDate: 'Ngày ban hành',
  processingStatus: 'Trạng thái xử lý',
  status: 'Tình trạng',
  modifier: 'Người sửa',
  modifiedDate: 'Ngày sửa',
  version: 'Phiên bản',
  documentType: 'Loại văn bản',
  field: 'Lĩnh vực',
  dataSource: 'Nguồn dữ liệu',
};

export const isTextarea = (key: string) => {
  if (
    key === 'SummaryOfSuggestedAI' ||
    key === 'KeywordAISuggestion' ||
    key === 'SuggestedAICategories'
  ) {
    return true;
  }

  return false;
};

export const isDisableField = (key: string) => {
  if (
    key === 'fullPath' ||
    key === 'createAt' ||
    key === 'creator' ||
    key === 'creatorId' ||
    key === 'DataSource' ||
    key === 'AccessLevel' ||
    key === 'category' ||
    key === 'fileName' ||
    key === 'version'
  ) {
    return true;
  }

  return false;
};

export const checkConditionUploadFiles = (files: FileList, toast: any) => {
  const maxFiles = 30;
  const maxSize = 50 * 1024 * 1024;

  if (files.length > maxFiles) {
    toast({
      title: 'Lỗi tải lên',
      description: `Bạn chỉ có thể tải lên tối đa ${maxFiles} tệp.`,
      variant: 'destructive',
    });
    return true;
  }

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    if (file && file.size > maxSize) {
      toast({
        title: 'Lỗi tải lên',
        description: `Tệp ${file.name} vượt quá giới hạn kích thước 50MB.`,
        variant: 'destructive',
      });
      return true;
    }
  }
  return false;
};

// Map sync status from English to Vietnamese
export const syncStatusMap: Record<string, string> = {
  STARTING: 'Đang bắt đầu',
  IN_PROGRESS: 'Đang đồng bộ',
  COMPLETE: 'Đồng bộ thành công',
  FAILED: 'Đồng bộ thất bại',
  STOPPING: 'Đang dừng',
  STOPPED: 'Đã dừng',
};

export const getSyncStatusInVietnamese = (status: string): string => {
  return syncStatusMap[status] || status;
};
